import React from 'react';
import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';

const ProDatePicker: React.FC<DatePickerProps> = React.forwardRef<
  any,
  DatePickerProps
>((props, ref) => {
  return (
    <DatePicker ref={ref} {...props} />
  );
});

export default ProDatePicker;
